import { invoke } from '@forge/bridge';

type RequestTypeResponse = {
    id: string;
    issueTypeId: string;
};

type GetServiceDeskResponse = {
    id: string;
    projectId: string;
    projectKey: string;
    projectName: string;
};

class ServiceDeskApi {
    getRequestType(serviceDeskId: string, requestTypeId: string): Promise<RequestTypeResponse> {
        return invoke('get-request-type', { serviceDeskId, requestTypeId });
    }

    getServiceDesk(serviceDeskId: string): Promise<GetServiceDeskResponse> {
        return invoke('get-service-desk', { serviceDeskId });
    }
}

export default new ServiceDeskApi();
